import React, { useState } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTable from "../components/Table";

const GoalTracking = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  const data = [
    { key: "1", type: "Project Goals", subject: "Programming Skills", target: "Complete JS Course", start: "14 Jan 2024", end: "14 Feb 2024", status: "Active", progress: "80%" },
    { key: "2", type: "Project Goals", subject: "Programming Skills", target: "Complete HTML Course", start: "14 Jan 2024", end: "14 Feb 2024", status: "Active", progress: "70%" },
    { key: "3", type: "Project Goals", subject: "Programming Skills", target: "Complete CSS Course", start: "14 Jan 2024", end: "14 Feb 2024", status: "Active", progress: "60%" },
  ];

  const filteredData = data.filter((item) =>
    item.subject.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { title: "", render: () => <input type="checkbox" />, width: 50 },
    { title: "Goal Type", dataIndex: "type" },
    { title: "Subject", dataIndex: "subject" },
    { title: "Target Achievement", dataIndex: "target" },
    { title: "Start Date", dataIndex: "start" },
    { title: "End Date", dataIndex: "end" },
    { title: "Status", dataIndex: "status" },
    { title: "Progress", dataIndex: "progress" },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Goal Tracking List"
      columns={columns}
      data={filteredData}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearchText}
    />
  );
};

export default GoalTracking;